import * as React from 'react';
import { Progress } from 'semantic-ui-react';

// Constants
const INTERVAL = 100;

interface Props {
    estimatedRequestTime: number;
    label?: string;
}

interface State {
    percent: number;
    elapsedTime: number;
    intervalId?: number;
}

/**
 * Fake the progress of of a request based on an estimate of how long it should take.
 */
export class FakeProgress extends React.PureComponent<Props, State> {
    state = {
        percent: 0,
        elapsedTime: 0,
        intervalId: undefined
    };

    componentDidMount(): void {
        const intervalId = window.setInterval(
            this.calculatePercentage,
            INTERVAL
        );
        this.setState({ intervalId });
    }

    componentWillUnmount(): void {
        this.clear();
    }

    calculatePercentage = (): void => {
        const { estimatedRequestTime } = this.props;
        const { elapsedTime } = this.state;

        const nextElapsedTime = elapsedTime + INTERVAL;
        const fraction = nextElapsedTime / estimatedRequestTime;
        const nextPercent = fraction < 1 ? fraction * 100 : 100;

        this.setState({
            elapsedTime: nextElapsedTime,
            percent: nextPercent
        });

        if (nextPercent >= 100) {
            this.clear();
        }
    };

    clear = (): void => {
        const { intervalId } = this.state;
        if (intervalId) {
            clearInterval(intervalId);
        }
    };

    render(): React.ReactElement {
        const { label } = this.props;
        const { percent } = this.state;

        return <Progress percent={percent}>{label}</Progress>;
    }
}

export default FakeProgress;
